import Cookies from "js-cookie"
import { html } from "lit-html"
import { virtual, useEffect, useState } from "haunted"
import { unsafeHTML } from "lit-html/directives/unsafe-html.js"
import { ROLE_ICON_MAP } from "../constants"

export const InternalNotesComponent = virtual(({ endpoint }) => {
  const [loading, setLoading] = useState(true)
  const [assignmentList, setAssignmentList] = useState([])
  const csrftoken = Cookies.get("csrftoken")

  const loadNotes = () => {
    fetch(endpoint, {
      method: "GET",
      credentials: "include",
      headers: {
        "X-CSRFToken": csrftoken,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setAssignmentList(res)
        setLoading(false)
      })
      .catch((err) => console.error(err))
  }

  useEffect(loadNotes, [])

  const RoleRow = (role) => {
    return html`
      <div id="note-${role.id}" class="mb-5">
        <div class="mb-3 leading-[24px] text-black">
          ${unsafeHTML(role.comments)}
        </div>
        <div class="flex items-center">
          <span
            class="mr-3 role-icon-link icon-inline rounded ${role.category.toLowerCase()}"
          >
            <i
              class="${role.category in ROLE_ICON_MAP
                ? ROLE_ICON_MAP[role.category]
                : "fas fa-pen-alt"} text-tiny"
            ></i>
          </span>
          <span class="text-sm text-gray-interactive">${role.category}</span>
        </div>
      </div>
    `
  }

  const AssignmentRow = (assignment, idx) => {
    return html`
      <div
        id="assignment-${assignment.id}"
        class="${idx === 0 ? `` : `border-t-px border-gray-border`} p-7"
      >
        ${assignment.roles.map((role) => RoleRow(role))}
        <div>
          <a href=${assignment.url} class="mb-2 block font-bold">
            ${assignment.name}
          </a>
          <div class="text-sm text-gray-interactive">
            ${assignment.date_time}
          </div>
        </div>
      </div>
    `
  }

  const content = assignmentList.map((assignment, idx) =>
    AssignmentRow(assignment, idx)
  )

  const emptyState = () => {
    return html`
      <div class="px-7 py-10 text-center text-gray-600">
        <i class="fas fa-sticky-note text-4xl mb-4 text-gray-400"></i>
        <p>No internal notes found</p>
      </div>
    `
  }

  return html`
    <div
      class="mb-9half border-px border-gray-border shadow-select-box rounded-lg pt-7 text-black"
    >
      <div class="px-7">
        <h2 class="text-xl font-serif font-bold">Internal Notes</h2>
        <p class="text-sm text-gray-interactive">
          Notes left by managers when reviewing Documenters' assignments. These
          internal notes are only visible to managers, they are not accessible
          by Documenters
        </p>
      </div>
      ${loading
        ? html`<div class="loader-container loading"></div>`
        : assignmentList.length === 0
        ? emptyState()
        : content}
    </div>
  `
})
